/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VatExemptionInputModel } from '../../models/vat-exemption-input-model';
import { VatExemptionModel } from '../../models/vat-exemption-model';

export interface PostApiVatExemptionV1Create$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: VatExemptionInputModel
}

export function postApiVatExemptionV1Create$Plain(http: HttpClient, rootUrl: string, params?: PostApiVatExemptionV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
  const rb = new RequestBuilder(rootUrl, postApiVatExemptionV1Create$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VatExemptionModel>;
    })
  );
}

postApiVatExemptionV1Create$Plain.PATH = '/private/v1/vat-exemptions/Create';
